import { useQuery } from "@apollo/client";
import { GET_DIAMOND_OPTIONS, tokenOptions } from "../../../backend/graphql";
import { useAppSelector } from "../../../app/hooks";

// The values the stock holds, for the selectors that offer a stone characteristic.
export type DiamondOptions = {
  gIAColors: string[];
  fancyIntensities: string[];
  fancySaturations: string[];
  fancyOvertones: string[];
  fancyColors: string[];
  langermanColors: string[];
  flatColors: string[];
  meleeColors: string[];
  shapes: string[];
  clarities: string[];
};

export function useDiamondOptionsQuery() {
  const token = useAppSelector((state) => state.auth.token);
  const { data, loading, error } = useQuery(
    GET_DIAMOND_OPTIONS,
    tokenOptions(token),
  );
  return {
    diamondOptions: data?.getDiamondOptions as DiamondOptions | undefined,
    loading,
    error,
  };
}

export function useDiamondOptions() {
  return useDiamondOptionsQuery().diamondOptions;
}
